/* eslint-disable no-unreachable */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const OldLogin = () => {
  const navigate = useNavigate();
  if (/(garmentory|treet|gently)/.test(window.location.href)) {
    return;
  }
  useEffect(() => {
    navigate('../');
  });
};
